/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/**
 *
 * ResourceEvidence
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
// import format from 'date-fns/format';
import Typography from '@material-ui/core/Typography';
import Mixpanel from 'utils/mixpanelService';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import Parser from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import { arrayToSentence } from 'utils/stringUtils';
import _get from 'lodash/get';
import _isUndefined from 'lodash/isUndefined';

const styles = theme => ({
  root: {
    marginTop: 20,
  },
  value: {
    ...theme.typography.overline,
    color: theme.palette.text.primary,
  },
  linkValue: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
  },
  normalText: {
    cursor: 'default',
    textDecoration: 'none',
    pointerEvents: 'none',
    color: theme.palette.text.primary,
  },
  evidence: {
    marginBottom: 10,
    '& a': {
      textDecoration: 'none',
      color: theme.palette.text.secondary,
    },
  },
  evidenceWrapper: {
    margin: 0,
    paddingLeft: 20,
    color: theme.palette.text.primary,
  },
});

const redirect = (url, location, id) => {
  Mixpanel.track('Source Exit - Clicked', {
    page: location.pathname,
    exitPage: url,
    component: 'ResourceEvidence',
    entryId: id,
  });
};

function getOrgs(orgs) {
  if (_isEmpty(orgs)) return null;
  const orgsName = [];
  orgs.forEach(org => {
    if (!_isEmpty(_get(org, 'fields.name'))) {
      orgsName.push(_get(org, 'fields.name'));
    }
  });
  return !_isEmpty(orgsName) ? arrayToSentence(orgsName) : '';
}

function ResourceEvidence({ location, data, title, classes }) {
  if (_isEmpty(data)) return null;
  const HtmlSourceLinks = [];
  data.forEach(item => {
    if (
      !_isEmpty(_get(item, 'fields')) &&
      !_isEmpty(_get(item, 'fields.article'))
    ) {
      const { article, organization = [], url, reviewStatus } = item.fields;
      const orgs = getOrgs(organization);
      let link = url;
      let normalText = false;
      if (
        _isUndefined(url) ||
        (!_isUndefined(reviewStatus) && reviewStatus !== 'Accepted')
      ) {
        link = '#';
        normalText = true;
      }
      // const year = !_isEmpty(citationYear) && format(citationYear, 'yyyy');
      HtmlSourceLinks.push({
        url: link,
        id: item.sys.id,
        source: `<span className=${classes.value}>${
          !_isEmpty(orgs) ? `<span>${orgs}</span>` : ''
        } <a href="${link}" target="_blank" rel="noopener" class="${
          classes.linkValue
        } ${normalText ? classes.normalText : ''} ">${article}</a></span>`,
      });
    }
  });
  return (
    <>
      {title && (
        <Grid item xs={12} className={classes.root}>
          <Typography variant="h4" color="textPrimary" gutterBottom>
            {title}
          </Typography>
        </Grid>
      )}

      <Grid item xs={12}>
        <ol className={classes.evidenceWrapper}>
          {HtmlSourceLinks.map(({ url, source, id }) => (
            <li
              className={classes.evidence}
              onClick={() => redirect(url, location, id)}
              key={url}
            >
              {Parser(source)}.
            </li>
          ))}
        </ol>
      </Grid>
    </>
  );
}

ResourceEvidence.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  location: PropTypes.object,
  title: PropTypes.string,
};

export default compose(
  withRouter,
  withStyles(styles),
)(ResourceEvidence);
